import { CircularLoader } from "@similarweb/ui-components";

import { LoaderWrapper } from "../../SwitchPackageStage.styled";

export const StageLoading = () => {
    return (
        <LoaderWrapper>
            <CircularLoader isLarge />
        </LoaderWrapper>
    );
};
